/* eslint-disable max-len */
import DocumentTitle from 'react-document-title';
import Radium from 'radium';
import React from 'react';
import chroma from 'chroma-js';

import ReindexTypography from './ui/_ReindexTypography';

const backgrounds = {
  teal: chroma('#7dccc8').alpha(0.15).css(),
  orange: chroma('#ef6900').alpha(0.15).css(),
  purple: chroma('#4e14ae').alpha(0.15).css(),
  blue: chroma('#3cd8ff').alpha(0.15).css(),
};

const { fontSizeToPx, rhythm } = ReindexTypography;
const maxWidth = 750;
const styles = {
  container: {
    marginTop: rhythm(-1.5),
    paddingTop: rhythm(1.5),
  },
  heading: {
    textAlign: 'center',
  },
  content: {
    maxWidth,
    margin: `0 auto`,
    padding: rhythm(1),
  },
  notes: {
    ...fontSizeToPx('80%'),
    textAlign: 'center',
    marginTop: rhythm(1),
    color: '#777',
  },
};

const padding = rhythm(1);
const gutter = rhythm(1.5);

const gridStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  margin: `-${gutter} 0 0 -${gutter}`,
  alignItems: 'stretch',
  paddingBottom: padding,
};
const columnStyle = {
  padding: `${gutter} 0 0 ${gutter}`,
  display: 'flex',
  flex: '0 0 50%',
  '@media (max-width: 570px)': {
    flex: '0 0 100%',
    textAlign: 'left',
  },
};

@Radium
export default class Team extends React.Component {
  render() {
    return (
      <DocumentTitle title={`Team | ${this.props.config.siteTitle}`}>
        <div style={styles.container}>
          <div style={styles.content}>
            <h1>About Us</h1>
            <p>
              <em>Reindex Software</em> is a team of software engineers focused on GraphQL, React.js and related open source technologies.
            </p>
            <p>
              We built Reindex, the first Backend as a Service platform based on GraphQL, because we needed an API for building mobile and web apps with JavaScript faster. We've enjoyed using React for frontend development since 2013 and it's changed the way we think about client-side code. But integrating client-side apps with various backend technologies and hosted databases using more or less RESTful APIs was a constant source of complexity. When Facebook introduced their approach for tackling this complexity with GraphQL and Relay, <a href="/blog/how-facebooks-graphql-will-change-backend-development/">we saw in this a huge potential</a> for the kind of applications we love to build. And we wanted a service for storing data with GraphQL that could be set up in minutes, without time consuming backend development, a "Firebase of GraphQL".<br />Reindex was born.
            </p>
            <h2>Services</h2>
            <p>
              We provide consulting and
              training services for companies wanting to make the most out of
              GraphQL, React and related technologies.
            </p>

            <div style={gridStyle}>
              <div style={columnStyle}>
                <div style={{ backgroundColor: backgrounds.blue, padding, flex: 1 }}>
                  <h3>GraphQL Training</h3>
                  <p>
                    If you want to get your engineering team up to speed with GraphQL and/or Relay we can lead an on-site training course tailored to your needs.
                  </p>
                  <p>
                    The course can cover the basics of GraphQL, Relay and scalable GraphQL server architecture, or go deeper in more advanced topics relevant to your application.
                  </p>
                </div>
              </div>
              <div style={columnStyle}>
                <div style={{ backgroundColor: backgrounds.teal, padding, flex: 1 }}>
                  <h3>Software Development</h3>
                  <p>
                    Whether it's building an MVP with React Native, moving your web app to React or developing a GraphQL API for all of your backend services, we're ready to jump in to help.
                  </p>
                  <p>
                    Reindex can deliver the whole project from an idea to a polished product or we can work together with your existing team of developers.
                  </p>
                </div>
              </div>
            </div>
            <p>
              Interested? Send an email to <a href="mailto:hello@reindex.io">hello@reindex.io</a> and tell us about your project!
            </p>
          </div>
        </div>
      </DocumentTitle>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./team.jsx
 **/